import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';
import { Calendar } from '@vk-hr-tek/core/calendar';

import { AbsenceEmployeeItem } from '@app/gen/dashboard';

@injectable()
export class AbsencesWidgetMapper {
  constructor(
    private format: FormatService,
    private calendar: Calendar,
  ) {}

  processAbsenceEmployeeItem(employee: AbsenceEmployeeItem) {
    const [firstName, middleName, lastName] = employee.fio?.split(' ') || '';

    const shortName = this.format.toShortName(firstName, middleName, lastName);
    const initials = `${firstName[0]}${middleName[0]}`;
    const start = this.format.toDate(employee.from_date || '');
    const end = this.format.toDate(employee.to_date || '');
    const duration = this.calendar.differenceInCalendarDays(
      new Date(employee.to_date || ''),
      new Date(employee.from_date || ''),
    );

    return {
      absenceTypeGroup: employee.absence_type_group,
      duration,
      end,
      fio: employee.fio,
      fromDate: employee.from_date,
      fullPosition: employee.full_position,
      initials,
      position: employee.position,
      roleModelEnabled: employee.role_model_enabled,
      shortName,
      start,
      toDate: employee.to_date,
      userId: employee.user_id,
    };
  }
}
